/* 符合条件的汽车的列表 */
import React, {
  useRef,
  useState,
  useEffect,
  useContext,
  useCallback,
} from 'react'
import Link from 'next/link'
import fetch from 'lib/decorated-fetch'
import classnames from 'classnames'
import ScrollLoader from 'Components/scroll-loader'

import getUrl from 'lib/url'
import { sendTeaCommEvent } from 'lib/tea-analyze'

import { Image } from 'Components/view-image'
import Loading from 'Components/loading'
import { useCityName } from 'Components/hooks'

import { ContextStore } from './reducer'
import { ISortProps, ICarProps } from './interface'

import { getZT } from 'lib/zt-util'

interface Props {
  sort: ISortProps[]
}
interface ICarData {
  /*  汽车总数量 */
  series_count?: number
  /* 汽车列表 */
  series: ICarProps[]
}

import Stars from '../home/components/dong-che-fen/stars'
import { getParamsFromState } from './helper'
import renderList from './car-list-item'

const star = require('./static/star.png')
const star_black = require('./static/w-star.png')
const carBg = require('static/car-bg-l.png')

export default function CarList({ sort }: Props) {
  // 已选中的条件
  const { state, dispatch } = useContext(ContextStore)
  // 获取当前城市
  const cityName = useCityName() || ''
  /* 懒加载剩余数量 */
  const count = useRef(0)
  /* 懒加载当前第几页 */
  const offset = useRef(0)

  const [loading, setLoading] = useState(true)
  /* 符合条件的汽车列表 */
  const [carData, setCarData] = useState<ICarData>({
    series: [],
    series_count: undefined,
  })

  // }, [state, state, cityName])

  // 处理请求参数，序列化已选择条件
  const getParams = useCallback(() => {
    return getParamsFromState(state)
  }, [state])
  // 统计用参数
  function getStat() {
    return Object.keys(state).reduce((acc: any, curr: string) => {
      acc[curr] = state[curr].map((item) => item.param).join(',')
      return acc
    }, {})
  }
  // 获取汽车类型
  const getCars = useCallback(() => {
    setLoading(true)
    return fetch(getUrl(`/motor/pc/car/brand/get_select_series`), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `offset=${offset.current}&limit=30&is_refresh=${
        offset.current ? 0 : 1
      }&city_name=${encodeURIComponent(cityName)}&${getParams()}`,
    })
  }, [cityName, getParams])

  useEffect(() => {
    offset.current = 0
    if (cityName) {
      getCars()
        .then((data) => {
          if (data.status === 0) {
            count.current = data.data.series_count
            setCarData(data.data)
          }
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
          // no-op
        })
    }
  }, [cityName, getCars])
  // 懒加载
  function loadMoreHandler() {
    count.current -= 30
    offset.current += 1
    getCars()
      .then((data) => {
        if (data.status === 0) {
          sendTeaCommEvent('load_garage_series', {
            list_item_num: data.data.series.length,
          })
          setCarData({
            series_count: data.data.series_count,
            series: [...carData.series, ...data.data.series],
          })
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  function renderButtons(id: number, name: string, car_ids: number[]) {
    return (
      <div className="button-wrap tw-grid tw-grid-cols-3 tw-gap-x-3">
        <Link
          key={'0'}
          href={`/dealer?seriesId=${id}&zt=${getZT('pc_home_top_series')}`}
          as={`/dealer/${id}?zt=${getZT('pc_home_top_series')}`}
        >
          <a
            target="_blank"
            className="item bg-button tw-col-span-1"
            key={`key-${id}`}
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'series_card_fun_btn',
                car_series_id: `${id}`,
                car_series_name: name,
                button_name: '询底价',
              })
            }}
          >
            询底价
          </a>
        </Link>
        <Link
          key={'1'}
          href={`/auto/images/detail?category=wg&seriesId=${id}`}
          as={`/auto/series/${id}/images/wg-x-x-x`}
        >
          <a
            target="_blank"
            className="item border-button tw-col-span-1"
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'series_card_fun_btn',
                car_series_id: `${id}`,
                car_series_name: name,
                button_name: '图片',
              })
            }}
          >
            图片
          </a>
        </Link>
        <Link
          key={'2'}
          href={`/auto/params?carIds=${car_ids}`}
          as={`/auto/params?carIds=${car_ids}`}
        >
          <a
            target="_blank"
            className="item border-button tw-col-span-1"
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'series_card_fun_btn',
                car_series_id: `${id}`,
                car_series_name: name,
                button_name: '配置',
              })
            }}
          >
            配置
          </a>
        </Link>
        <style jsx>
          {`
            .button-wrap {
              position: absolute;
              left: 20px;
              right: 20px;
              bottom: 20px;
              height: 30px;
            }
            a {
              height: 28px;
              line-height: 28px;
              font-size: 12px;
              text-align: center;
            }
            .bg-button {
              border-radius: 2px;
              background-color: #ffcc32;
            }
            .bg-button:hover {
              color: #1f2129;
              background: #f5c530;
            }
            .border-button {
              border-radius: 2px;
              border: solid 0.5px #c9cbd6;
            }
            .border-button:hover {
              color: #1f2129;
              background: #e6e8f2;
            }
          `}
        </style>
      </div>
    )
  }

  function renderList(data: ICarProps, index: number) {
    return (
      <li
        key={`car-${index}`}
        className="item-car-wrap tw-col-span-3 xl:tw-col-span-2 tw-h-254 md:tw-h-290 lg:tw-h-302 xl:tw-h-262 2xl:tw-h-288"
      >
        <Link
          key={index}
          href={`/auto/series?seriesId=${data.id || data.info?.series_id}`}
          as={`/auto/series/${data.id || data.info?.series_id}`}
        >
          <a
            key={`car-${index}`}
            className="item-link"
            target="_blank"
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'car_series_card_content',
                car_series_name: data.outter_name,
                car_series_id: `${data?.id}`,
                brand_id: `${data?.brand_id}`,
                brand_name: data?.brand_name || '',
              })
            }}
          >
            <p
              className={`
              image-wrapper
              tw-h-100 tw-w-150
              md:tw-h-135 md:tw-w-203
              lg:tw-h-148 lg:tw-w-222
              xl:tw-h-108 xl:tw-w-162
              2xl:tw-h-133 2xl:tw-w-200
              `}
            >
              <Image
                src={data.cover_url}
                width={400}
                height={266}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  width: '100%',
                  transform: 'translate(-50%, -50%)',
                }}
                lazy={true}
                cusDefaultImg={carBg}
              />
            </p>
            <p
              className="car-name"
              title={data.outter_name || data.info?.series_name}
            >
              {data.outter_name || data.info?.series_name}
            </p>
            <div className="dcar-score">
              <span className="star-bg" />
              {data.dcar_score > 0 ? (
                <>
                  <span className="score">{data.dcar_score}</span>
                  <div className="score-star">
                    <Stars
                      starIcon={star}
                      starVacantIcon={star_black}
                      className="stars"
                      score={data.dcar_score}
                      maxScore={5}
                      starWidth={10}
                      starHeight={10}
                    />
                  </div>
                </>
              ) : (
                <span className="no-score">暂无评分</span>
              )}
            </div>
            <p className="price">
              {data.dealer_price || data.info?.dealer_price}
            </p>
          </a>
        </Link>
        {renderButtons(
          data.id || data.info?.series_id,
          data.info?.series_name,
          data.car_ids
        )}
        <style jsx>
          {`
            a:hover {
              color: #1f2129;
            }
            .item-car-wrap {
              position: relative;
              display: inline-block;
              text-align: center;
              box-sizing: border-box;
              background: #fff;
              transition: all 0.3s ease-in-out;
            }
            .item-car-wrap:hover {
              box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
            }

            .image-wrapper {
              position: absolute;
              top: 12px;
              left: 50%;
              transform: translate(-50%);
              overflow: hidden;
            }

            .car-name {
              position: absolute;
              bottom: 112px;
              font-weight: 500;
              left: 0;
              right: 0;
              text-align: center;
              font-size: 16px;
            }
            .dcar-score {
              position: absolute;
              bottom: 84px;
              font-weight: 500;
              left: 0;
              right: 0;
              text-align: center;
              font-size: 12px;
            }

            .star-bg {
              display: inline-block;
              background-size: cover;
              background-position: center;
              background-image: url(${require('static/dcar-score.png')});
              width: 32px;
              height: 12px;
              vertical-align: middle;
            }
            .score-star {
              padding: 0 2px;
              display: inline-block;
              vertical-align: middle;
            }
            .no-score {
              padding-left: 2px;
              color: #9897a0;
              vertical-align: middle;
            }
            .score {
              vertical-align: middle;
              font-size: 14px;
              padding: 0 2px;
            }
            .name:hover {
              color: #406599;
            }
            .price {
              color: #e62021;
              font-size: 14px;
              position: absolute;
              bottom: 64px;
              left: 0;
              right: 0;
              font-family: DINAlternate;
              text-align: center;
            }
          `}
        </style>
      </li>
    )
  }

  function isOptionActive(option: ISortProps, index: number): boolean {
    if (!option) {
      return false
    }
    // 如果没有删选默认显示第一个
    if (!state[option.key] && index === 0) {
      return true
    }
    if (
      state[option.key] &&
      state[option.key].some((item) => item.param === option.param)
    ) {
      return true
    }
    return false
  }

  return (
    <React.Fragment>
      <header>
        <span className="active">{carData.series_count}</span> 车系符合条件
        <div className="conditions">
          {sort.map((item: ISortProps, index) => {
            return (
              <span
                key={item.text}
                role="button"
                className={`price-sort ${classnames({
                  active: isOptionActive(item, index),
                  'after-line': index > 0,
                })}`}
                onClick={(e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
                  e.stopPropagation()
                  sendTeaCommEvent('clk_event', {
                    event_id: 'series_card_sort_btn',
                    button_name: item.text,
                  })
                  dispatch({
                    type: 'setSingleOption',
                    payload: {
                      key: item.key,
                      text: item.text,
                      param: item.param,
                    },
                  })
                }}
              >
                {item.text}
              </span>
            )
          })}
        </div>
      </header>
      {carData.series_count === 0 && (
        <div className="empty-tip">抱歉，未找到合适车型</div>
      )}
      <div className="list-wrap">
        <ScrollLoader
          loading={loading}
          end={count.current - 30 >= 0 ? false : true}
          loadMoreHandler={loadMoreHandler}
        >
          <ul className="list tw-grid tw-grid-cols-12 tw-gap-x-12 tw-gap-y-16">
            {carData.series.map((item: ICarProps, index: number) =>
              renderList(item, index)
            )}
          </ul>
          {loading && <Loading />}
        </ScrollLoader>
      </div>
      <style jsx>
        {`
          header {
            height: 72px;
            box-sizing: border-box;
            padding-top: 36px;
            font-size: 14px;
            background: #f2f4fa;
          }
          .conditions {
            float: right;
          }
          .conditions span {
            position: relative;
            padding-left: 24px;
            cursor: pointer;
            font-size: 14px;
            transition: color 0.1s ease-in-out;
          }
          .after-line:after {
            content: '';
            width: 1px;
            height: 14px;
            background-color: #c9cbd6;
            position: absolute;
            left: 12px;
            top: 3px;
          }
          .price-sort:hover {
            color: #e62021;
          }
          .price-sort.active {
            color: #e62021;
          }
          .active {
            color: #ff9100;
          }
          .list-wrap {
            background: #f2f4fa;
            text-align: center;
            padding-bottom: 36px;
          }
          .empty-tip {
            text-align: center;
            font-size: 16px;
            padding: 80px 0;
            color: #606370;
          }
        `}
      </style>
    </React.Fragment>
  )
}
